// export the lobTypeCodes from pdf-tools instead of duplicating them here
export { lobTypeCodes } from '@certificate_hero/enums';
